import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typography, sizeVars } from '@routific/hive/v5';
import { observer } from 'mobx-react';
import { TimelineViolationTypes } from '../../helpers/lateness';
import OrderWarning, { OrderWarningType } from '../orders/OrderWarning';
import { VisitDtoModelType } from '../../store/mst/models';

interface Props {
  visit: VisitDtoModelType;
  showLateness?: boolean;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizeVars.space[50]};
`;

const TimeWindows: React.FC<Props> = ({
  visit, showLateness,
}) => {
  const { t } = useTranslation('common');

  const startTime = visit.activeTimeWindow?.startTimeString;
  const endTime = visit.activeTimeWindow?.endTimeString;

  const getTimeText = () => {
    if (startTime && !endTime) {
      return `${t('orderDetails.deliverBetween.after')} ${startTime}`;
    }
    if (!startTime && endTime) {
      return `${t('orderDetails.deliverBetween.before')} ${endTime}`;
    }
    if (startTime && endTime) {
      return visit.timeWindowString;
    }
    return null;
  };

  const renderLateness = () => {
    const hasLatenessViolation = !!visit.timeline?.violations?.find((v) => v.type === TimelineViolationTypes.LATENESS || v.type === TimelineViolationTypes.EARLINESS);
    if (hasLatenessViolation) {
      return <OrderWarning types={[OrderWarningType.LATENESS] } />;
    }
    return null;
  };

  const timeText = getTimeText();

  // TODO: Add Lateness to the ODP in the Orders Page
  // Jira: https://routific.atlassian.net/browse/ROUT-14689
  return (
    <StyledDiv data-cy="stop-timewindow" data-testid="stop-timewindow">
      {showLateness && renderLateness()}
      {timeText && <Typography variant="body">{timeText}</Typography>}
    </StyledDiv>
  );
};

export default observer(TimeWindows);
